export const SORT_TYPES = {
	DEFAULT: 'DEFAULT',
	STATUS: 'STATUS',
	SIGNERS: 'SIGNERS',
	DATE: 'DATE',
	DOCUMENT: 'DOCUMENT',
};
